import classNames from 'classnames/bind';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft } from '@fortawesome/pro-regular-svg-icons/faChevronLeft';
import { faChevronRight } from '@fortawesome/pro-regular-svg-icons/faChevronRight';

import PerPage from './PerPage';

import { usePagination, DOTS } from '../../../../hooks/usePagination';

import Styles from './styles.module.scss';

const cx = classNames.bind(Styles);

const Pagination = ({
  currentPage,
  totalCount,
  pageSize,
  siblingCount = 1,
  setCurrentPage,
  setSelectedValue,
  className,
  rightAligned = false,
  skipMobileValues = false,
  isDisable = false,
  fixedSizeFilterData = [],
}) => {
  const paginationRange = usePagination({
    currentPage,
    totalCount,
    siblingCount,
    pageSize,
  });

  const onNext = () => {
    if (isDisable) return;
    setCurrentPage(currentPage + 1);
  };

  const onPrevious = () => {
    if (isDisable) return;
    setCurrentPage(currentPage - 1);
  };

  const onCurrentPage = (pageNumber) => {
    if (isDisable) return;
    setCurrentPage(pageNumber);
  };

  const lastPage = paginationRange[paginationRange.length - 1];
  return (
    <div className={cx('pagination', { 'right-aligned': rightAligned, disable: isDisable })}>
      <PerPage
        selectedValue={pageSize}
        setSelectedValue={setSelectedValue}
        skipMobileValues={skipMobileValues}
        isDisable={isDisable}
        fixedSizeFilterData={fixedSizeFilterData}
      />
      <ul
        className={cx('pagination-container', { [className]: className })}
      >
        <li className={cx('pagination-item-title')}>
          Page:
        </li>
        <li
          className={cx('pagination-item-arrow', {
            disabled: currentPage === 1,
          })}
          onClick={onPrevious}
        >
          <div className={cx('arrow', 'left')}>
            <FontAwesomeIcon icon={faChevronLeft} />
          </div>
        </li>
        <ul className={cx('pagination-item-lists')}>
          {paginationRange.map((pageNumber) => {
            if (pageNumber === DOTS) {
              return '...';
            }

            return (
              <li
                key={pageNumber}
                className={cx('pagination-item', {
                  selected: pageNumber === currentPage,
                })}
                onClick={() => onCurrentPage(pageNumber)}
              >
                {pageNumber}
              </li>
            );
          })}
        </ul>
        <li
          className={cx('pagination-item-arrow', {
            disabled: currentPage === lastPage,
          })}
          onClick={onNext}
        >
          <div className={cx('arrow', 'right')}>
            <FontAwesomeIcon icon={faChevronRight} />
          </div>
        </li>
      </ul>
    </div>
  );
};

export default Pagination;
